/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Footer from './footer/footer';
import OpcUaMqttPubSub from 'utilities/PubSub/OpcUaMqttPubSub';
import TemplateTypeDetailPubSub from 'views/TemplateTypeDetailPubSub';

type IPubSubDetailParams = {
  machine: string;
  fairTag?: string;
  typeId: string;
};

export default function PubSubDetail() {
  const params = useParams() as IPubSubDetailParams;
  const typeId = params.typeId;
  const machineId = decodeURIComponent(params.machine);
  const fairTag = params.fairTag;
  //const topic = 'isw/fakepublish/BasicMachineTool';
  const topic = 'company/client/ShowcaseMachineTool'; // TODO: PubSub - Create topic from machine id

  const [scrolledToTop, setScrolledToTop] = useState(false);

  useEffect(() => {
    if (!scrolledToTop) {
      window.scrollTo(0, 0);
    }
    setScrolledToTop(true);
  }, [topic, scrolledToTop]);

  return (
    <main className="footer-wrapper" style={{ scrollBehavior: 'auto' }}>
      <OpcUaMqttPubSub topicPath={topic}>
        <TemplateTypeDetailPubSub fairTag={fairTag} machineId={machineId} typeId={typeId} />
      </OpcUaMqttPubSub>
      <div className="container-max">
        <Footer />
      </div>
    </main>
  );
}
